export class EventStatistic {
 constructor(
   public ticketTotal = '0',
   public activeTicket = '0',
   public totalSessionTime = '0',
   public lessThen25percent = '0',
   public moreThen25percent = '0',
   public moreThen50percent = '0',
   public moreThen75percent = '0',
 ) {
 }
}
